import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AuthErrorI, AuthStateI, MaintenanceI, Role, UserI } from '../types/auth';

const initAuthState: AuthStateI = {
  user: {
    email: '',
    name: '',
    company: '',
    phone: '',
    role: 'user',
    tokens: {
      access_token: '',
      refresh_token: ''
    }
  },
  error: {
    code: '',
    message: ''
  },
  maintenance: {
    active: false,
    eta: null
  },
  loading: false,
  registerSuccess: false,
  activateSuccess: false,
  resetSuccess: false,
  newPasswordSuccess: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initAuthState,
  reducers: {
    validateSession: (state, action: PayloadAction<UserI>) => {
      state.user = action.payload;
    },
    setTokens: (state, action: PayloadAction<{ access_token: string; refresh_token: string }>) => {
      state.user.tokens = action.payload;
    },
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.user.email = action.payload;
    },
    userLogout: (state) => {
      state.user = initAuthState.user;
    },
    setAuthError: (state, action: PayloadAction<AuthErrorI>) => {
      state.error = action.payload;
    },
    setRegisterSuccess: (state, action: PayloadAction<boolean>) => {
      state.registerSuccess = action.payload;
    },
    setPasswordRessetSuccess: (state, action: PayloadAction<boolean>) => {
      state.resetSuccess = action.payload;
    },
    setUserRole: (state, action: PayloadAction<Role>) => {
      state.user.role = action.payload;
    },
    setMaintenance: (state, action: PayloadAction<MaintenanceI>) => {
      state.maintenance = action.payload;
    },
  }
});

export const {
  validateSession,
  userLogout,
  setUserEmail,
  setAuthError,
  setTokens,
  setRegisterSuccess,
  setPasswordRessetSuccess,
  setUserRole,
  setMaintenance
} = authSlice.actions;

export default authSlice.reducer;
